import { connect } from 'react-redux'
import { SortableElement } from 'react-sortable-hoc'
import { OnList } from '../styles'
import ResponseCard from './ResponseCard'
import { useLocation } from 'react-router-dom'
import { generateSlug } from 'utils/helpers'

const SortableResponseItemUncategorized = SortableElement((props) => {
  const { pathname } = useLocation();

  const getCurrentResponseSlugFromUrl = () => {
    const urlToArray = pathname?.split('/');
    return urlToArray[urlToArray.length - 1]
  }

  return (
    <OnList className={`${!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && !props.value.is_accessible ? 'disabled' : ''} ${generateSlug(props.value) === getCurrentResponseSlugFromUrl() ? 'active' : ''}`}>
      <ResponseCard response={props.value} is_categorized={false} />
    </OnList>
  )
})

const mapStateToProps = (state) => ({
  isFree: state.company.company.isFree,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  is_subscribed: state.subscription.is_subscribed
})
export default connect(mapStateToProps, null)(SortableResponseItemUncategorized)
